function NumbersCounter() {
  const sections = document.querySelectorAll('.numbers, .content-image__numbers, .proof-cards');

  if (!sections.length) {
    return;
  }

  const animateCounter = (counter) => {
    if (counter.dataset.counted === 'true') {
      return;
    }

    const target = Number(counter.dataset.target || 0);
    const suffix = counter.dataset.suffix || '';

    if (!target) {
      counter.textContent = `0${suffix}`;
      counter.dataset.counted = 'true';
      return;
    }

    const start = 1;
    const duration = 1400;
    const startTime = performance.now();

    const update = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.floor(start + ((target - start) * eased));

      counter.textContent = `${value}${suffix}`;

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        counter.textContent = `${target}${suffix}`;
        counter.dataset.counted = 'true';
      }
    };

    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      entry.target.querySelectorAll('[data-counter="true"]').forEach(animateCounter);
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.35,
  });

  sections.forEach((section) => observer.observe(section));
}

export default NumbersCounter;
